import { proposeQuoteMaterials } from "@workspace/api-client-react";
import { materialProposalRequestSchema, materialProposalResponseSchema } from "@workspace/api-zod/material-allowance";
import type { MaterialsLine } from "@workspace/api-zod/materials-list";

// A single bounded queue avoids per-row concurrency errors and render-triggered retries.
let tail = Promise.resolve();
const requests = new Map<string, { expires: number; result: ReturnType<typeof request> }>();
const request = async (line: MaterialsLine, libraryOnly: boolean) => materialProposalResponseSchema.parse(await proposeQuoteMaterials(
  materialProposalRequestSchema.parse({ libraryOnly, line: { ...line, quantity: Number(line.quantity),
    unitCost: Number(line.unitCost), materialCost: Number(line.materialCost ?? 0) } })));
export function automaticMaterials(key: string, line: MaterialsLine, canRun: () => boolean = () => true, libraryOnly = false) {
   key = `source-v3:${libraryOnly ? "library" : "identify"}:${key}`;
  const now = Date.now();
  for (const [id, item] of requests) if (item.expires < now) requests.delete(id);
  const cached = requests.get(key);
  if (cached) return cached.result;
  const result = tail.then(() => {
    if (!canRun()) throw new DOMException("No longer needed", "AbortError");
    return request(line, libraryOnly);
  });
  tail = result.then(() => undefined, () => undefined);
  requests.set(key, { expires: now + 15 * 60_000, result });
   void result.catch(() => { requests.delete(key); });
  if (requests.size > 150) requests.delete(requests.keys().next().value!);
  return result;
}
export function materialFailureMessage(error: unknown) {
  const status = (error as { status?: number })?.status;
  if (status === 401) return "Please sign in again to identify materials.";
  if (status === 403) return "Material suggestions require UK builder access. You can enter materials manually.";
  if (status === 429 || /\b429\b/.test(String((error as Error)?.message))) return "Material lookup could not be completed. Retry the lookup or enter materials manually.";
  return "Material not matched – please enter manually.";
}
